(function () {
  'use strict';

  var COLOR_NAMES = ['color', 'colour', 'tono', 'color'];
  var SIZE_NAMES = ['size', 'talla', 'taille', 'sizes'];
  var SWATCH_LIMIT = 5;
  var IMG_RE = /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i;

  function resizeImg(src, suffix) {
    if (!src) return '';
    return src.replace(IMG_RE, function (_, ext) { return '_' + suffix + '.' + ext.toLowerCase(); });
  }

  function formatMoney(cents, currency) {
    var cur = currency || 'USD';
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100) + ' ' + cur;
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  function optionIndex(product, names) {
    for (var i = 0; i < product.options.length; i++) {
      if (names.indexOf(product.options[i].toLowerCase()) !== -1) return i;
    }
    return -1;
  }

  function colorContextOn() {
    var cfg = window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.customColorContext;
    return cfg && cfg.enable ? cfg : null;
  }

  function VlzQuickShop() {
    this.drawer = document.getElementById('vlz-qs-drawer');
    this.overlay = document.getElementById('vlz-qs-overlay');
    if (!this.drawer || !this.overlay) return;

    this.thumb = document.getElementById('vlz-qs-thumb');
    this.titleEl = document.getElementById('vlz-qs-title');
    this.priceEl = document.getElementById('vlz-qs-price');
    this.compareEl = document.getElementById('vlz-qs-compare');
    this.swatchesEl = document.getElementById('vlz-qs-swatches');
    this.moreColorsEl = document.getElementById('vlz-qs-more-colors');
    this.sizeBtnsEl = document.getElementById('vlz-qs-size-btns');
    this.atcBtn = document.getElementById('vlz-qs-atc');
    this.closeBtn = document.getElementById('vlz-qs-close');
    this.productLinkEl = document.getElementById('vlz-qs-product-link');

    this.currency = this.drawer.dataset.currency || 'USD';
    this.product = null;
    this.selectedColorIdx = null;
    this.selectedVariantId = null;
    this.colorOptionPos = -1;
    this.sizeOptionPos = -1;
    this._prevOverflow = '';

    this._bindEvents();
  }

  VlzQuickShop.prototype._bindEvents = function () {
    var self = this;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vlz-quick-shop]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.dataset.vlzQuickShop;
      var url = btn.dataset.vlzQuickShopUrl || ('/products/' + handle);
      self._open(handle, url);
    });

    this.closeBtn.addEventListener('click', function () { self._close(); });
    this.overlay.addEventListener('click', function () { self._close(); });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) self._close();
    });

    this.atcBtn.addEventListener('click', function () { self._addToCart(); });
  };

  VlzQuickShop.prototype._open = function (handle, productUrl) {
    var self = this;

    // Re-query all DOM refs fresh to avoid stale references after section re-renders
    this.thumb        = document.getElementById('vlz-qs-thumb');
    this.titleEl      = document.getElementById('vlz-qs-title');
    this.priceEl      = document.getElementById('vlz-qs-price');
    this.compareEl    = document.getElementById('vlz-qs-compare');
    this.swatchesEl   = document.getElementById('vlz-qs-swatches');
    this.moreColorsEl = document.getElementById('vlz-qs-more-colors');
    this.sizeBtnsEl   = document.getElementById('vlz-qs-size-btns');
    this.atcBtn       = document.getElementById('vlz-qs-atc');
    this.closeBtn     = document.getElementById('vlz-qs-close');
    this.productLinkEl= document.getElementById('vlz-qs-product-link');
    this.drawer       = document.getElementById('vlz-qs-drawer');
    this.overlay      = document.getElementById('vlz-qs-overlay');

    if (!this.drawer || !this.overlay) {
      console.error('[VlzQS] Drawer elements missing from DOM');
      return;
    }

    // Reset state
    this.selectedColorIdx = null;
    this.selectedVariantId = null;
    this.atcBtn.disabled = true;
    this.atcBtn.textContent = 'ADD TO BAG';
    this.titleEl.textContent = '';
    this.priceEl.textContent = '';
    this.compareEl.hidden = true;
    this.swatchesEl.innerHTML = '';
    this.sizeBtnsEl.innerHTML = '';
    this.moreColorsEl.hidden = true;
    // El drawer es compartido: sin este reset la clase quedaría de un producto anterior.
    this.moreColorsEl.classList.remove('custom_color_options-more');
    this.thumb.src = '';

    /* La URL se guarda en la instancia porque el enlace TRY IT ON es opcional
       (settings.custom_qs_show_try_on) y el "+N COLORS" también la necesita. */
    this.productUrl = productUrl;
    if (this.productLinkEl) this.productLinkEl.href = productUrl;

    // Open drawer
    this._prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    this.overlay.classList.add('is-active');
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');

    // Read product data embedded in the card DOM — no fetch needed
    var dataEl = document.querySelector('.vlz-pd[data-h="' + handle + '"]');
    if (!dataEl) {
      console.error('[VlzQS] No data element for handle: "' + handle + '"');
      return;
    }

    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[VlzQS] JSON parse error:', e.message);
      return;
    }

    product.handle = handle;
    self.product = product;

    try {
      self._render(product, productUrl);
    } catch (e) {
      console.error('[VlzQS] render error:', e);
    }
  };

  VlzQuickShop.prototype._close = function () {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-active');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = this._prevOverflow;
  };

  VlzQuickShop.prototype._render = function (product, productUrl) {
    var self = this;

    this.colorOptionPos = optionIndex(product, COLOR_NAMES);
    this.sizeOptionPos = optionIndex(product, SIZE_NAMES);

    // Title
    this.titleEl.textContent = product.title;

    // Product page link
    this.productUrl = productUrl || product.url;
    if (this.productLinkEl) this.productLinkEl.href = this.productUrl;

    /* Show TRY IT ON and SIZE GUIDE only for products with VTO enabled. Las dos son
       funciones de la PDP, así que SIZE GUIDE también apunta a la ficha del producto. */
    var tryOnEl = document.getElementById('vlz-qs-product-link');
    var sizeGuideEl = this.drawer.querySelector('.vlz-qs-size-guide');
    var vtoVisible = product.vto_enabled ? '' : 'none';
    if (tryOnEl) tryOnEl.style.display = vtoVisible;
    if (sizeGuideEl) {
      sizeGuideEl.href = this.productUrl;
      sizeGuideEl.style.display = vtoVisible;
    }

    // Thumb — first image
    if (product.images && product.images.length) {
      this.thumb.src = resizeImg(product.images[0], '120x');
      this.thumb.alt = product.title;
    }

    // Price from first available variant
    var firstVariant = product.variants[0];
    this._renderPrice(firstVariant);

    // Colors
    if (product.color_options && product.color_options.items && product.color_options.items.length) {
      this._renderColorLinks(product.color_options);
    } else if (this.colorOptionPos >= 0) {
      this._renderColors(product);
    }

    // Sizes (no color filter yet — show all)
    this._renderSizes(product, null);
  };

  VlzQuickShop.prototype._renderPrice = function (variant) {
    if (!variant) return;
    this.priceEl.textContent = formatMoney(variant.price, this.currency);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      this.compareEl.textContent = formatMoney(variant.compare_at_price, this.currency);
      this.compareEl.hidden = false;
    } else {
      this.compareEl.hidden = true;
    }
  };

  // Color options del metafield: cada color es otro producto, así que el swatch es un
  // enlace a su PDP y no cambia la variante. A propósito no se llama a _selectColor: sin
  // filtro de color _render deja las tallas del producto actual y el ATC sigue igual.
  //
  // Con settings.custom_color_context_enable el swatch además publica data-cco-handle y el "+N"
  // data-cco-more: custom_color_context.js los intercepta y llama a setProduct() para cambiar el
  // color aquí mismo. El href se mantiene en los dos casos (ctrl+clic, sin JS, ajuste apagado).
  VlzQuickShop.prototype._renderColorLinks = function (data) {
    var items = data.items || [];
    var ctx = colorContextOn();
    this.swatchesEl.innerHTML = '';

    items.forEach(function (entry) {
      var a = document.createElement('a');
      a.className = 'vlz-qs-swatch' + (entry.current ? ' is-active' : '');
      a.href = entry.url;
      if (entry.name) {
        a.title = entry.name;
        a.setAttribute('aria-label', entry.name);
      }
      if (entry.style) a.setAttribute('style', entry.style);
      if (ctx && entry.handle) {
        a.setAttribute('data-cco-handle', entry.handle);
        if (entry.name) a.setAttribute('data-cco-name', entry.name);
        if (entry.sku) a.setAttribute('data-cco-sku', entry.sku);
      }
      this.swatchesEl.appendChild(a);
    }, this);

    var extra = (data.total || items.length) - items.length;
    if (extra > 0) {
      this.moreColorsEl.textContent = '+' + extra + ' COLORS';
      this.moreColorsEl.href = this.productUrl || '#';
      this.moreColorsEl.classList.add('custom_color_options-more');
      this.moreColorsEl.hidden = false;
      if (ctx && ctx.drawerAll && this.product && this.product.handle) {
        this.moreColorsEl.setAttribute('data-cco-more', this.product.handle);
      } else {
        this.moreColorsEl.removeAttribute('data-cco-more');
      }
    } else {
      this.moreColorsEl.hidden = true;
      this.moreColorsEl.removeAttribute('data-cco-more');
    }
  };

  /* ------------------------------------------------------------------------
     Contexto interno de color: cambiar de producto sin cerrar el drawer.
     custom_color_context.js trae el payload (tiene su propia caché) y aquí sólo se
     re-renderiza, reusando _render tal cual.
     ------------------------------------------------------------------------ */

  VlzQuickShop.prototype.setProduct = function (product, productUrl, keepSize) {
    this.selectedColorIdx = null;
    this.selectedVariantId = null;
    this.product = product;

    this._render(product, productUrl);

    if (!keepSize) return;
    var btns = this.sizeBtnsEl.querySelectorAll('.vlz-qs-size');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.size === keepSize && !btns[i].disabled) {
        this._selectSize(keepSize, null);
        return;
      }
    }
  };

  VlzQuickShop.prototype.currentSize = function () {
    var active = this.sizeBtnsEl && this.sizeBtnsEl.querySelector('.vlz-qs-size.is-active');
    return active ? active.dataset.size : null;
  };

  VlzQuickShop.prototype.colorOptions = function () {
    return (this.product && this.product.color_options) || null;
  };

  VlzQuickShop.prototype.vtoEnabled = function () {
    return !!(this.product && this.product.vto_enabled);
  };

  VlzQuickShop.prototype._renderColors = function (product) {
    var self = this;
    var colorPos = this.colorOptionPos;
    var optKey = 'option' + (colorPos + 1);

    // Collect unique colors with their first representative variant
    var seen = {};
    var colorEntries = [];
    product.variants.forEach(function (v) {
      var color = v[optKey];
      if (!color || seen[color]) return;
      seen[color] = true;
      colorEntries.push({ color: color, variant: v });
    });

    this.swatchesEl.innerHTML = '';

    var visible = colorEntries.slice(0, SWATCH_LIMIT);
    var hidden = colorEntries.slice(SWATCH_LIMIT);

    visible.forEach(function (entry, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vlz-qs-swatch';
      btn.title = entry.color;
      btn.dataset.color = entry.color;

      var swatchStyle = product.swatches && product.swatches[entry.color];
      if (swatchStyle) {
        btn.setAttribute('style', swatchStyle);
      }

      btn.addEventListener('click', function () {
        self._selectColor(entry.color);
      });

      self.swatchesEl.appendChild(btn);
    });

    if (hidden.length > 0) {
      this.moreColorsEl.textContent = '+' + hidden.length + ' COLORS';
      this.moreColorsEl.href = this.productUrl || '#';
      this.moreColorsEl.hidden = false;
    } else {
      this.moreColorsEl.hidden = true;
    }

    // Auto-select first color
    if (visible.length > 0) {
      this._selectColor(visible[0].color);
    }
  };

  VlzQuickShop.prototype._selectColor = function (color) {
    var self = this;
    var product = this.product;
    var colorPos = this.colorOptionPos;
    var optKey = 'option' + (colorPos + 1);

    this.selectedColorIdx = color;
    this.selectedVariantId = null;
    this.atcBtn.disabled = true;

    // Update swatch active state
    var swatches = this.swatchesEl.querySelectorAll('.vlz-qs-swatch');
    swatches.forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.color === color);
    });

    // Update thumb to first variant image of this color
    var colorVariants = product.variants.filter(function (v) { return v[optKey] === color; });
    var firstWithImg = colorVariants.find(function (v) { return v.featured_image; });
    if (firstWithImg) {
      this.thumb.src = resizeImg(firstWithImg.featured_image.src, '120x');
    }

    // Update price from first available variant of this color
    var firstAvail = colorVariants.find(function (v) { return v.available; }) || colorVariants[0];
    if (firstAvail) this._renderPrice(firstAvail);

    // Re-render sizes for this color
    this._renderSizes(product, color);
  };

  VlzQuickShop.prototype._renderSizes = function (product, filterColor) {
    var self = this;
    var sizePos = this.sizeOptionPos;

    this.sizeBtnsEl.innerHTML = '';
    this.selectedVariantId = null;
    this.atcBtn.disabled = true;

    if (sizePos < 0) {
      // No size option — if single variant or color-only, auto-select first available
      var colorPos = this.colorOptionPos;
      var optKey = colorPos >= 0 ? 'option' + (colorPos + 1) : null;
      // Sin filtro de color se aceptan todas las variantes, igual que hace la rama con
      // tallas: si no, un producto de solo color nunca resolvería variante y el ATC
      // quedaría deshabilitado.
      var candidate = product.variants.filter(function (v) {
        return (!optKey || !filterColor || v[optKey] === filterColor);
      });
      var avail = candidate.find(function (v) { return v.available; });
      if (avail) {
        self.selectedVariantId = avail.id;
        self.atcBtn.disabled = false;
      }
      return;
    }

    var sizeOptKey = 'option' + (sizePos + 1);
    var colorOptKey = this.colorOptionPos >= 0 ? 'option' + (this.colorOptionPos + 1) : null;

    // Collect unique sizes and availability
    var seen = {};
    var sizeEntries = [];
    product.variants.forEach(function (v) {
      var size = v[sizeOptKey];
      if (!size) return;
      var matchesColor = !colorOptKey || !filterColor || v[colorOptKey] === filterColor;
      if (!matchesColor) return;
      if (!seen[size]) {
        seen[size] = { size: size, available: false, variant: v };
        sizeEntries.push(seen[size]);
      }
      if (v.available) seen[size].available = true;
    });

    sizeEntries.forEach(function (entry) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vlz-qs-size';
      btn.textContent = entry.size;
      btn.dataset.size = entry.size;
      if (!entry.available) btn.disabled = true;

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        self._selectSize(entry.size, filterColor);
      });

      self.sizeBtnsEl.appendChild(btn);
    });
  };

  VlzQuickShop.prototype._selectSize = function (size, filterColor) {
    var self = this;
    var product = this.product;
    var sizePos = this.sizeOptionPos;
    var colorPos = this.colorOptionPos;
    var sizeOptKey = 'option' + (sizePos + 1);
    var colorOptKey = colorPos >= 0 ? 'option' + (colorPos + 1) : null;

    // Update size button active state
    var sizeBtns = this.sizeBtnsEl.querySelectorAll('.vlz-qs-size');
    sizeBtns.forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.size === size);
    });

    // Find matching variant
    var match = product.variants.find(function (v) {
      var sizeMatch = v[sizeOptKey] === size;
      var colorMatch = !colorOptKey || !filterColor || v[colorOptKey] === filterColor;
      return sizeMatch && colorMatch;
    });

    if (match) {
      this.selectedVariantId = match.id;
      this._renderPrice(match);
      this.atcBtn.disabled = !match.available;
    }
  };

  VlzQuickShop.prototype._addToCart = function () {
    var self = this;
    if (!this.selectedVariantId) return;

    this.atcBtn.disabled = true;
    this.atcBtn.textContent = 'ADDING…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: this.selectedVariantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error');
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        self.atcBtn.textContent = 'ADDED ✓';
        // Update cart count badge
        var countEvt = new Event('cart:count:update');
        countEvt.detail = { item_count: cart.item_count };
        document.dispatchEvent(countEvt);
        // Re-render cart drawer / mini-cart
        document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
        setTimeout(function () { self._close(); }, 900);
      })
      .catch(function () {
        self.atcBtn.textContent = 'ERROR – TRY AGAIN';
        self.atcBtn.disabled = false;
        setTimeout(function () {
          self.atcBtn.textContent = 'ADD TO BAG';
        }, 2500);
      });
  };

  // Preload card images as they enter the viewport (before hover/click)
  function preloadCardImages(card) {
    if (card.dataset.preloaded) return;
    card.dataset.preloaded = '1';
    var pdEl = card.querySelector('.vlz-pd');
    if (!pdEl) return;
    var pd;
    try { pd = JSON.parse(pdEl.textContent); } catch (e) { return; }
    // Preload up to 5 additional images per card
    (pd.images || []).slice(1, 6).forEach(function (src) {
      var img = new Image();
      img.src = resizeImg(src, '533x');
    });
  }

  function observeCards() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: preload all visible cards immediately
      document.querySelectorAll('[data-product-id]').forEach(preloadCardImages);
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        preloadCardImages(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '400px 0px' }); // start 400px before card enters view

    document.querySelectorAll('[data-product-id]').forEach(function (card) {
      observer.observe(card);
    });
  }

  // Card image arrow navigation
  function cardSlide(btn, dir) {
    var media = btn.closest('.hdt-card-product__media');
    var card = btn.closest('[data-product-id]');
    if (!media || !card) return;

    var mainImg = media.querySelector('.hdt-card-product__media--main');
    if (!mainImg) return;

    var pdEl = card.querySelector('.vlz-pd');
    if (!pdEl) return;

    var pd;
    try { pd = JSON.parse(pdEl.textContent); } catch (e) { return; }

    var images = pd.images || [];
    if (images.length <= 1) return;

    var idx = parseInt(media.dataset.slideIdx || '0', 10);
    idx = ((idx + dir) + images.length) % images.length;
    media.dataset.slideIdx = idx;

    // Update main image
    mainImg.src = resizeImg(images[idx], '533x');
    mainImg.srcset = '';

    // Also update the hover image to the SAME src so it's immediately visible
    // while the user is hovering over the card to click the arrows
    var hoverImg = media.querySelector('.hdt-card-product__media--hover');
    if (hoverImg) {
      hoverImg.src = resizeImg(images[idx], '533x');
      hoverImg.srcset = '';
    }
  }
  window.vlzCardSlide = cardSlide;

  // Mobile swipe on card images
  (function () {
    var swipeStartX = 0;
    var swipeStartY = 0;
    var MIN_SWIPE_PX = 30;

    document.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) < MIN_SWIPE_PX || Math.abs(dy) > Math.abs(dx)) return;
      var wrap = e.target.closest('.vlz-card-img-wrap');
      if (!wrap) return;
      cardSlide(wrap, dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  // Init — expose globally so onclick attributes can call it directly
  function init() {
    if (document.getElementById('vlz-qs-drawer') && !window.vlzQS) {
      window.vlzQS = new VlzQuickShop();
    }
    observeCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
